<template>
  <div class="coach-info">
    <div v-if="coachLength > 1" class="coach-info__title">
      <div class="coach-info__label">{{ index > 0 ? 'Второй' : 'Первый' }} тренер сборной</div>
      <Button
        class="coach-info__delete-coach"
        variant="primary"
        size="xs"
        icon-left="delete"
        @click="deleteCoach"
      >
        Удалить тренера
      </Button>
    </div>
    <Select
      opacity
      placeholder="Выбери тренера из списка"
      required
      label="Тренер"
      :value="coach"
      :options="options"
      :option-text="'name'"
      :option-key="'id'"
      :option-disabled="item => coachList.some(c => c.id === item.id)"
      @input="setCoach"
    />
    <template v-if="coach && coach.id">
      <Input
        class="coach-info__business"
        disabled
        :value="coach.businessName"
        :error="false"
        type="text"
        label="Название бизнеса"
      />
      <Button
        v-if="coachLength < 2"
        class="coach-info__add-coach"
        variant="primary"
        size="xs"
        icon-left="ui-plus-circle"
        @click="addCoach"
      >
        Добавить тренера
      </Button>
      <div
        v-for="(achievement, achievementIndex) in coach.achievements"
        :key="achievementIndex"
        class="coach-info__achievement"
      >
        <div class="coach-info__achievement-desc">Достижение {{ achievementIndex + 1 }}</div>
        <div class="coach-info__achievement-value">
          {{ achievement }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Select from '@/components/UiKit/v2/Select';
import Button from '@/components/UiKit/v2/Button';
import Input from '@/components/UiKit/v2/Input';

export default {
  components: {
    Button,
    Input,
    Select
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    coach: {
      type: Object,
      default: () => ({ id: 0, fullname: '', achievements: [] })
    },
    coachList: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    coachLength() {
      return this.coachList.length;
    }
  },
  methods: {
    setCoach(coach) {
      this.$emit('change', { value: coach, index: this.index });
    },
    addCoach() {
      this.$emit('addCoach');
    },
    deleteCoach() {
      this.$emit('deleteCoach', this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.coach-info {
  &__achievement {
    display: flex;
    flex-direction: column;

    &-desc {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.3px;
      color: #ababba;
      white-space: pre;
      margin-bottom: 5px;
    }

    &-value {
      min-height: 90px;
      background: #f7f7fb;
      border-radius: 4px;
      padding: 16px 14px;
      margin-bottom: 16px;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: -0.3px;
      color: #76767b;
    }
  }

  &__business {
    margin-bottom: 16px;
  }

  &__add-coach {
    padding: 6px 16px;
    left: 0;
    top: 87px;
    margin-bottom: 16px;

    &::v-deep.ui-kit-v2-button {
      background-color: #f7f8fc;
      color: $ui-light-grey-4-5-contrast;
      min-width: unset;

      &:hover:not([disabled]) {
        background-color: #f7f8fc;
      }
    }
  }

  &__title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__label {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    display: flex;
    align-items: center;
    letter-spacing: -0.3px;
    color: #2b2d34;
  }

  &__delete-coach.ui-kit-v2-button {
    color: #36383e;
    padding: 0;
    font-weight: normal;
    background-color: transparent;
    border: none;

    &::v-deep {
      svg path {
        fill: #898989 !important;
      }
    }

    &:hover::v-deep {
      svg path {
        fill: $ui-red !important;
      }
    }
  }
}
</style>
